import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Language } from '../models/language';
import { extractErrorMessage } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  baseUrl: string = environment.api_url;
  constructor(private readonly http: HttpClient) { }

    // GET all languages
    getAllLanguages(): Observable<Language[]> {
      return this.http.get<Language[]>(`${this.baseUrl}/languages`).pipe(
        catchError(err => throwError(() => extractErrorMessage(err)))
      );
    }
  
    // GET single language by ID
    getLanguageById(id: number): Observable<Language> {
      return this.http.get<Language>(`${this.baseUrl}/languages/${id}`).pipe(
        catchError(err => throwError(() => extractErrorMessage(err)))
      );
    }
  
    create(language: Omit<Language, 'id'> & { id: number | null }): Observable<Language> {
      return this.http.post<Language>(`${this.baseUrl}/languages`, language).pipe(
        catchError(err => throwError(() => extractErrorMessage(err)))
      );
    }

    update(language: Language): Observable<Language> {
      return this.http.put<Language>(`${this.baseUrl}/languages`, language).pipe(
        catchError(err => throwError(() => extractErrorMessage(err)))
      );
    }    
}
